import { Routes } from '@angular/router';
import { EditaisComponent } from './editais.component';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';

export const editaisRoutes: Routes = [
  {
    component: EditaisComponent,
    path: 'editais',
    data: {
      title: 'Editais',
      breadcrumb: [{ label: 'Editais', url: '/editais' }],
    },
    canActivate: [AuthGuard],
  },
];
